<template>
  <div class="w-full register-form">
    <form>
      <div class="mb-10 flex flex-row items-center justify-center">
        <BaseIcon class="mr-2" name="logo" width="28" height="32" />
        <div class="font-bold text-xs">Информирование граждан. Регистрация</div>
      </div>

      <div class="flex flex-col mb-2">
        <BaseLabel for-id="provider_code">Код поставщика информации</BaseLabel>
        <div class="flex flex-row">
          <div class="w-4/5 mr-2">
            <BaseInput
              v-model="formData.providerCode"
              id="provider_code"
              :hasError="hasFormError('provider_code')"
              @input="isNewProvider()"
            />
          </div>
          <BaseButton
            size="xs"
            variant="blue-transparent"
            :disabled="isLoadProvider"
            @click="findDataProvider(formData.providerCode)"
          >
            <BaseLoader v-if="isLoadProvider" size="xs" class="mr-1" />
            Найти
          </BaseButton>
        </div>
        <BaseError v-if="hasFormError('provider_code')">
          {{ getFormError('provider_code') }}
        </BaseError>
      </div>
      <div class="mb-2">
        <BaseLabel for-id="provider_name">Наименование поставщика</BaseLabel>
        <BaseTextarea
          class="textarea"
          v-model="formData.providerName"
          id="provider_name"
          :disabled="true"
        />
      </div>
      <div class="mb-2">
        <BaseLabel for-id="name">Имя</BaseLabel>
        <BaseInput
          v-model="formData.name"
          id="name"
          :hasError="hasFormError('name')"
        />
        <BaseError v-if="hasFormError('name')">
          {{ getFormError('name') }}
        </BaseError>
      </div>
      <div class="mb-2">
        <BaseLabel for-id="last_name">Фамилия</BaseLabel>
        <BaseInput
          v-model="formData.lastName"
          id="last_name"
          :hasError="hasFormError('last_name')"
        />
        <BaseError v-if="hasFormError('last_name')">
          {{ getFormError('last_name') }}
        </BaseError>
      </div>
      <div class="mb-2">
        <BaseLabel for-id="email">Электронная почта</BaseLabel>
        <BaseInput
          v-model="formData.email"
          id="email"
          :hasError="hasFormError('email')"
        />
        <BaseError v-if="hasFormError('email')">
          {{ getFormError('email') }}
        </BaseError>
      </div>
      <div class="mb-8">
        <BaseLabel for-id="phone">Контактный телефон</BaseLabel>
        <BaseInput
          v-model="formData.phone"
          id="phone"
          :hasError="hasFormError('phone')"
        />
        <BaseError v-if="hasFormError('phone')">
          {{ getFormError('phone') }}
        </BaseError>
      </div>
      <div class="mb-4">
        <BaseButton
          class="w-full"
          size="md"
          variant="blue"
          :disabled="isLoading || !isFoundProvider"
          @click="signUp"
        >
          <BaseLoader v-if="isLoading" size="xs" class="mr-1" />
          Зарегистрироваться
        </BaseButton>
      </div>
      <div>
        <BaseLink class="w-full text-center text-sm" to="auth.login" >
          Авторизация
        </BaseLink>
      </div>
    </form>
  </div>
</template>

<script>
  import Client from '@/classes/Api/Client';
  import WithHttpError from '@/components/mixins/WithHttpError';

  import BaseLink from '@/components/global/base-link';
  import BaseIcon from '@/components/global/base-icon';
  import BaseLabel from '@/components/global/base-label';
  import BaseInput from '@/components/global/base-input';
  import BaseError from '@/components/global/base-error';
  import BaseButton from '@/components/global/base-button';
  import BaseLoader from '@/components/global/base-loader';
  import BaseTextarea from '@/components/global/base-textarea';

  export default {
    name: 'RegisterPage',

    components: {
      BaseLink,
      BaseIcon,
      BaseLabel,
      BaseInput,
      BaseTextarea,
      BaseError,
      BaseButton,
      BaseLoader,
    },

    mixins: [WithHttpError],

    data() {
      return {
        formData: {
          email: null,
          name: null,
          phone: null,
          lastName: null,
          providerCode: null,
          providerName: null,
        },

        isLoading: false,
        isLoadProvider: false,
        isFoundProvider: false,
      };
    },

    methods: {
      isNewProvider() {
        this.isFoundProvider = false;
        this.formData.providerName = '';
      },

      isDisabled(field) {
        return this.disabledFields.indexOf(field) !== -1;
      },

      findDataProvider(code) {
        if (!(!this.isLoadProvider && (this.isLoadProvider = true))) {
          return;
        }

        return Client.findDataProvider(code)
          .then((response) => {
            let data = response.data;
            this.formData.providerName = data.name;
            this.clearFormErrors();
            this.isFoundProvider = true;
          })
          .catch(this.prepareHttpError, () => {
            this.isFoundProvider = false;
          })
          .finally(() => {
            this.isLoadProvider = false;
          });
      },

      signUp() {
        if (!(!this.isLoading && (this.isLoading = true))) {
          return;
        }

        this.clearFormErrors();

        Client.signUp(
          this.formData.name,
          this.formData.lastName,
          this.formData.email,
          this.formData.phone,
          this.formData.providerCode
        )
          .then(() => {
            this.$router.push({name: 'auth.register.info'});
          })
          .catch(this.prepareHttpError)
          .catch(() => {
            this.$store.commit('Notification/showAlert', {
              title: 'Ошибка!',
              message:
                'Произошла ошибка, пожалуйста попробуйте отправить форму еще раз.',
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .register-form {
    width: rem(312px);
  }

  .textarea {
    background-color: #f5f5f5 !important;
  }
</style>
